import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Box, Text, getPaletteColor } from 'pcln-design-system'

const Cell = styled(Box)`
  display: inline-block;
  vertical-align: top;
  line-height: 1.8;
  text-align: center;
  width: 100%;
  height: 50px;
`
const Price = styled(Box)`
  color: ${(props) =>
    props.isSelected ? getPaletteColor('text.lightest') : getPaletteColor('pricePrimary.base')};
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
`

export class CustomDayWithPrice extends React.Component {
  static propTypes = {
    day: PropTypes.string.isRequired,
    customDayProps: PropTypes.shape({
      price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
    isValid: PropTypes.bool,
    isSelected: PropTypes.bool,
  }

  static defaultProps = {
    isValid: false,
  }

  currency = '$'

  render() {
    const { day, customDayProps, isValid, isSelected } = this.props
    const displayedPrice = isValid && customDayProps ? `${this.currency}${customDayProps.price}` : ''

    return (
      <Cell>
        <Text bold fontWeight='bold' fontSize={2}>
          {day}
        </Text>
        {displayedPrice && <Price isSelected={isSelected}>{displayedPrice}</Price>}
      </Cell>
    )
  }
}

export default CustomDayWithPrice
